export const processSchoolData = (data) => {

  const obj= data?.aedschoolpage;
  

  const InfoTitleCA =
    obj?.contentArticle?.results?.[0]?.description?.content?.[0]
      .content[0].text;

  const MultiScroll =
    obj?.scrollingbanner?.results?.[0]?.banners?.results;
  const BannerVideo = obj?.staticbanner?.results?.[0];

  const AvatarImg =
    obj?.profiledetails?.results[0].image?.results?.[0].fileUrl;

  const SchoolFees =
    obj?.schoolfees?.results?.[0].description?.content[0]
      .content[0].text;

  const InfoGridData =
    obj?.multibanner?.results?.[0]?.banners?.results;

    const stateSpeaks= obj?.primarycalltoactions?.results?.[0]?.banners?.results;

    const stateSpeaksTitle= obj?.primarycalltoactions?.results?.[0]?.title;
    const bannerVideo= obj?.staticbanner?.results?.[0];
    const executiveInfo= obj?.profiledetails?.results?.[0];
    const executiveInfoDesc= obj?.contentArticle?.results?.[0]?.description
    ?.content?.[0]?.content?.[0]?.text;

    const accreditation = obj?.secondarycontentarticle?.results?.[0];
    const feeRange = obj?.schoolfees?.results?.[0];
    const feeRangeTitle = obj?.schoolfees?.results?.[0]?.title;
    const parentTour = obj?.secondarystaticbanner?.results?.[0];
    const schoolFacilities = obj?.teritiarycontentarticle?.results?.[0];
    const scholarshipProgram = obj?.teritiarycontentarticle?.results?.[1];
    const faqs = obj?.faqs?.results?.[0];
    const maplocator = obj?.maplocator?.results?.[0];
    const relatedschools = obj?.relatedschools?.results;
    const relatedschoolTitle = obj?.quaternarycontentarticle?.results?.[0]?.title;
    const enquireNow = obj?.quaternarycontentarticle?.results?.[0]?.link?.results?.[0];
    const buttoncolor = obj?.buttoncolor;
    const backgroundcolor = obj?.backgroundcolor;
    const name = obj?.name;

  return {
    InfoTitleCA,
    MultiScroll,
    BannerVideo,
    AvatarImg,
    InfoGridData,
    SchoolFees,
    stateSpeaks,
    stateSpeaksTitle,
    bannerVideo,
    executiveInfo,
    executiveInfoDesc,
    accreditation,
    feeRange,
    feeRangeTitle,
    parentTour,
    schoolFacilities,
    scholarshipProgram,
    faqs,
    maplocator,
    relatedschools,
    relatedschoolTitle,
    enquireNow,
    buttoncolor,
    backgroundcolor,
    name
  };
};

export const processThankYouData = (data) => {
  const obj = data?.aedthankyoupage

  const title = obj?.contentarticle?.results?.[0]?.title;
  const description =
  obj?.contentarticle?.results?.[0]?.description?.content?.[0]?.content[0]
      ?.text;
  const exploreMore = obj?.links?.results?.[0]?.name;
  const exploreMoreLink = obj?.links?.results?.[0]?.hyperlink;
  const externallink= obj?.links?.results?.[0]?.externallink;
  const findRightOne = obj?.links?.results?.[1]?.name;
  const metadata = obj?.metadata?.results?.[0];

  return {
    title,
    description,
    exploreMore,
    exploreMoreLink,
    findRightOne,
    metadata,
    externallink
  };
};

export const processCtaPopUpData = (data) => {
  const obj= data?.aedschoolpage;
  
  const feeCta = obj?.schoolfees?.results?.[0] ?? null;
  const skillsCta = obj?.multibanner?.results?.[0]?.banners?.results?.[1] ?? null;
  const clubsCta = obj?.multibanner?.results?.[0]?.banners?.results?.[2] ?? null;
  const coCurricularCta = obj?.multibanner?.results?.[0]?.banners?.results?.[3] ?? null;

  return {
    feeCta,
    skillsCta,
    clubsCta,
    coCurricularCta
  };
};